module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.5e809c17f25d1cf3fb68.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.svg
// module chunks = 2